import moment from "moment";
import Button from "../../common/Button/Button";
import {ArrowRightOutlined} from "@ant-design/icons";
import BrowserRouter, {BrowserRoutes} from "../../../routes/BrowserRouter";
import React from "react";
import {IAlert} from "../../../api/Alert/Alert.types";

export const AlertsTableConfig = () => {
    return [
        {
            title: 'Alert Date', dataIndex: 'alert_for_date', key: 'alert_for_date',
            render: alertDate => {
                if (alertDate){
                    return moment(alertDate).format("MMM DD, YYYY")
                } else {
                    return alertDate;
                }
            }
        },
        // {
        //     title: 'Contracts', dataIndex: 'contracts', key: 'contracts',
        //     render: (contracts:string) => {
        //         if (contracts){
        //             return contracts.split(",").length;
        //         } else {
        //             return 0;
        //         }
        //     }
        // },
        {
            title: 'Opportunities', dataIndex: 'opportunities', key: 'opportunities',
            render: (opportunities:string) => {
                if (opportunities){
                    return opportunities.split(",").length;
                } else {
                    return 0;
                }
            }
        },
        {
            key: 'actions', render: (alert: IAlert) => {
                return (
                    <div className='table-row-actions'>
                        <Button icon={<ArrowRightOutlined/>} iconPosition="right"
                                onClick={() => BrowserRouter.push(BrowserRoutes.getAlertById(alert.id))}>
                            Details
                        </Button>
                    </div>
                )
            }
        }
    ]
}